import vuetify from '../../plugins/vuetify'
import i18n from '../../i18n/i18n';

const messages = {
	ar: {
		tooltip: [
			"تحديث سعر العملة",
			"عرض سجل تحديثات العملة",
			"كشف",
			"عرض ملفات المُستخدم",
			"استعراض محتويات الملف",
			"جرد مواد المستودع" ,
			"إرفاق لوغو" ,
		]
	},
	en: {
		tooltip: [
			"Update exchange rate",
			"Exchange rate history",
			"Statement",
			"Show user files",
			"Preview file",
			"Warehouse items inventory",
			"Attach logo",
		]
	},
	es: {
		tooltip: [
			"Actualizar tipo de cambio",
			"Mostrar historial de tipos de cambio",
			"Estado",
			"Mostrar archivos de usuario",
			"Vista previa del archivo",
			"Inventario de artículos de almacén",
			"Adjuntar logo",
		]
	}
}

export const LstColor_beeBtnIcon = [
    {
      type: "cached",
      color: vuetify.userPreset.theme.themes.light.addingColor,
      icon: "fa-sync",
      tooltip: messages[i18n.locale].tooltip[0]
    },
    {
      type: "history",
      color: vuetify.userPreset.theme.themes.light.grey,
      icon: "fa-history",
      tooltip: messages[i18n.locale].tooltip[1]
    },
    {
      type: "statement",
      color: vuetify.userPreset.theme.themes.light.displayingColor,
      icon: "far fa-share-square fa-rotate-180",
      tooltip: messages[i18n.locale].tooltip[2]
    },
	{
		type: "folder",
		color: vuetify.userPreset.theme.themes.light.grey,
		icon: "fa-folder-open",
		tooltip: messages[i18n.locale].tooltip[3]
	},
	{
		type: "show-file",
		color: vuetify.userPreset.theme.themes.light.grey,
		icon: "fa-arrow-circle-right",
		tooltip: messages[i18n.locale].tooltip[4]
	},
	{ 
		type: "inventory", 
		color: vuetify.userPreset.theme.themes.light.unactive, 
		icon: "fa-list", 
		tooltip: messages[i18n.locale].tooltip[5]
	},
	{ 
		type: "upload", 
		color: vuetify.userPreset.theme.themes.light.offWhite, 
		icon: "fa-paperclip", 
		tooltip: messages[i18n.locale].tooltip[6]
	}

];